import type { MutationHookOptions } from '@apollo/client'
import {
  GetTrainingsDocument,
  UpdateTrainingStatusDocument,
  UpdateTrainingStatusMutation,
  UpdateTrainingStatusMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  UpdateTrainingStatusMutation,
  UpdateTrainingStatusMutationVariables
>

export const useUpdateTrainingStatus = (options?: Options) => {
  const [updateTrainingStatus, { loading }] = useMutation(UpdateTrainingStatusDocument, {
    ...options,
    extractorFn: (data) => data.trainingsMutations.updateStatusTrainingsTraining,
  })

  return {
    loading,
    updateTrainingStatus(variables: UpdateTrainingStatusMutationVariables) {
      return updateTrainingStatus({
        variables,
        refetchQueries: [GetTrainingsDocument],
        awaitRefetchQueries: true,
      })
    },
  }
}
